<template>
  <a-upload
    name="file"
    list-type="picture-card"
    class="avatar-uploader"
    :show-upload-list="false"
    action="/merchant.php/upload_file/uploadFile?type=ATTRIBUTE"
    :before-upload="beforeUpload"
    @change="handleChange"
  >
    <video
      v-if="posterUrl"
      :src="imageUrl"
      :poster="posterUrl"
    />
    <div v-else>
      <a-icon :type="loading ? 'loading' : 'plus'" />
      <div class="ant-upload-text">
        上传视频
      </div>
    </div>
  </a-upload>
</template>

<script>
function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

export default {
  data() {
    return {
      loading: false,
      imageUrl: this.value,
      posterUrl: ''
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    onlyBmp: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(val) {
      this.imageUrl = val
      if (val) this.isLoad(val + '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto')
    }
  },
  created: function () {
    // 解决刚保存好的封面不加载
    var imgUrl = this.imageUrl
    if (imgUrl) this.isLoad(imgUrl + '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto')
  },
  methods: {
    // 上传图片
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = imageUrl
        })
        const res = info.file.response
        if (res.code === 200) {
          const videoUrl = res.data.url
          this.$emit('input', videoUrl)
          if (res.data.isMpeg) {
            this.isLoad(videoUrl + '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto')
          } else {
            this.posterUrl = videoUrl
            this.loading = false
          }
        }
      }
    },
    // 上传图片前
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'video/mp4'
      if (!isJpgOrPng) {
        this.$message.error('只能上传mp4格式的视频!')
      }
      // 视频上限
      var file_max = 200 * 1024 * 1024
      if (file.size > file_max) {
        this.$message.error('视频大小不能超过200M!')
        return false
      }
      this.posterUrl = ''
      return isJpgOrPng
    },
    // 因过程需要转码，需判断图片是否加载完成
    isLoad(url) {
      const timer = setInterval(() => {
        this.checkImgExists(url).then(() => {
          this.posterUrl = url
          clearInterval(timer)
          this.loading = false
        })
      }, 1000)
    },
    // 判断封面连接是否有效的盒子
    checkImgExists(imgurl) {
      return new Promise(function(resolve) {
        const ImgObj = new Image()
        ImgObj.src = imgurl
        ImgObj.onload = function(res) {
          resolve(res)
        }
      })
    }
  }
}
</script>
<style>
.avatar-uploader {
  width: auto;
}
.ant-upload.ant-upload-select-picture-card{
  margin-right: 0;
  margin-bottom: 0;
  width: 104px;
  height: 104px
}
.ant-upload.ant-upload-select-picture-card > .ant-upload{
  padding: 0
}
.avatar-uploader video {
  width: 102px;
  height: 97px;
}
</style>
